<template>
  <div class="container admin">
    <div class=""
         style="fontWeight:700;color: #303133">
      认证管理
    </div>
    <div class="filters card">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">
        <el-form-item label="用户信息"
                      prop="keyword">
          <el-input v-model="query.keyword"
                    placeholder="输入姓名/手机号"></el-input>
        </el-form-item>
        <!-- <el-form-item label="院校"
                      prop="college">
          <el-input v-model="query.college"
                    placeholder="输入院校名称/代码"></el-input>
        </el-form-item>
        <el-form-item label="专业"
                      prop="major">
          <el-input v-model="query.major"
                    placeholder="输入专业名称/代码"></el-input>
        </el-form-item>
        <el-form-item label="状态"
                      prop="status">
          <el-select v-model="query.status"
                     placeholder="请选择"
                     @change="fetchSeniorApplyList(query)">
            <el-option v-for="item in filter.status"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="邀请人"
                      prop="status">
          <el-select v-model="query.invite_info"
                     placeholder="请选择"
                     @change="fetchSeniorApplyList(query)">
            <el-option v-for="(item, index) in invite_options"
                       :key="index"
                       :label="item.invite_info"
                       :value="item.invite_info">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <!-- <div class="action-wrap">
        <el-button type="primary"
                   @click="handleSearch">搜索</el-button>
        <el-button @click="handleFormReset('searchForm')">重置</el-button>
      </div> -->
    </div>
    <div class="results card">
      <div class="values-header "
           style="display:flex; justify-content: space-between;">
        <div class="header-title">
          <p class="blue"></p>
          <p class="title">用户列表</p>
        </div>
        <el-form :inline="true"
                 label-width="70px"
                 size="small">
          <el-form-item>
            <el-radio-group v-model="query.status"
                            @change="fetchSeniorApplyList(query)">
              <el-radio-button v-for="(item, index) in filter.status"
                               :key="index"
                               :label="item.value">
                {{ item.label }}
              </el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div class="values">
        <el-table :data="results"
                  border
                  style="width: 100%"
                  @selection-change="handleSelectionChange">
          <el-table-column type="selection"
                           width="50"
                           align="center"> </el-table-column>
          <el-table-column prop="id"
                           label="用户ID"
                           width="80"
                           align="center">
          </el-table-column>
          <el-table-column prop="apply_time_type"
                           label="认证类型"
                           width="90"
                           align="center">
            <template slot-scope="scope">

              <el-tag v-if="scope.row.apply_time_type==1">首次认证</el-tag>
              <el-tag v-if="scope.row.apply_time_type==2"
                      type="warning">修改认证</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="avatar"
                           label="头像"
                           width="90"
                           align="center">
            <template slot-scope="scope">
              <el-avatar :src="scope.row.avatar"
                         v-if="scope.row.avatar"
                         style="width:30px;height:30px"></el-avatar>
            </template>
          </el-table-column>
          <el-table-column prop="realname"
                           label="姓名"
                           min-width="120"
                           align="center">
          </el-table-column>
          <el-table-column prop="nickname"
                           label="昵称（身份）"
                           width="120"
                           align="center">
            <template slot-scope="scope">
              <span style="color: #409EFF; cursor: pointer;"
                    @click="handleNickname(scope.row)">{{scope.row.nickname}}</span>
              <img src="https://upload.kaoyanbox.net/4125d739ef565bcebdf15341a3b2ca6d.png"
                   class="seniorImg"
                   v-if="scope.row.gender==1" />
              <img src="https://upload.kaoyanbox.net/c5ec7546bb6eb9670436dbd119dc5bb5.png"
                   class="seniorImg"
                   v-if="scope.row.gender==2" />
            </template>
          </el-table-column>

          <el-table-column prop="addmiassion"
                           label="录取信息"
                           width="420"
                           show-overflow-tooltip
                           align="left">
            <template slot-scope="scope">
              <span>{{scope.row.recruit_year}}年 | {{scope.row.recruit_college_name}} | {{scope.row.recruit_academy_name}} | ({{scope.row.recruit_major_code}}){{scope.row.recruit_major_name}}
                | ({{scope.row.recruit_direction_code}}) {{scope.row.recruit_direction_name}}</span>
            </template>
          </el-table-column>

          <el-table-column prop="subject"
                           label="考试科目"
                           width="590"
                           show-overflow-tooltip
                           align="left">
            <template slot-scope="scope">

              <span>{{scope.row.subject.join(',')}}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="mobile"
                           label="手机号"
                           min-width="160"
                           align="center">
          </el-table-column>
          <el-table-column label="院校"
                           min-width="160"
                           align="center">
            <template slot-scope="scope">
              <span>({{ scope.row.recruit_college_code || "-" }}){{
                  scope.row.recruit_college_name || "-"
                }}</span>
            </template>
          </el-table-column>
          <el-table-column label="专业"
                           min-width="160"
                           align="center">
            <template slot-scope="scope">
              <span>({{ scope.row.recruit_major_code || "-" }}){{
                  scope.row.recruit_major_name || "-"
                }}</span>
            </template>
          </el-table-column> -->
          <!-- <el-table-column label="录取方向"
                           min-width="160"
                           align="center">
            <template slot-scope="scope">
              <span>{{
                  scope.row.recruit_direction_name|| ""
                }}</span>
            </template>
          </el-table-column> -->
          <el-table-column prop="initial_test_score"
                           label="总分"
                           width="80"
                           align="center">
            <template slot-scope="scope">
              <span>{{
                  scope.row.initial_test_score|| ""
                }}分</span>
            </template>
          </el-table-column>
          <el-table-column prop="honor_tags_apply"
                           label="个人荣誉"
                           width="170"
                           show-overflow-tooltip
                           align="center">
            <template slot-scope="scope">
              <span>{{
                  scope.row.honor_tags_apply|| "-"
                }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态"
                           width="90"
                           align="center">
            <template slot-scope="scope">
              <el-tag type="warning"
                      size="mini"
                      v-show="scope.row.status == 0">待审核</el-tag>
              <el-tag type="success"
                      size="mini"
                      v-show="scope.row.status == 1">已通过</el-tag>
              <el-tag type="danger"
                      size="mini"
                      v-show="scope.row.status == 2">已驳回</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="invite_info"
                           label="邀请人"
                           width="90"
                           align="center">
          </el-table-column>

          <el-table-column label="申请时间"
                           min-width="160"
                           align="center">
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.create_time).format("YYYY-MM-DD HH:mm")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="审核时间"
                           min-width="160"
                           align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.status==1">{{
                $moment(scope.row.update_time).format("YYYY-MM-DD HH:mm")
              }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           width="120"
                           align="center"
                           fixed="right"
                           v-if="isfixed">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="text"
                         @click="handleToApplyInfo(scope.row, scope.$index)">审核</el-button>
              <el-button class="remove-text-button"
                         size="mini"
                         type="text"
                         @click="handleToRemove(scope.row, scope.$index)">删除</el-button>
            </template>
          </el-table-column>
          <el-table-column label=""
                           width="40"
                           align="center"
                           fixed="right"
                           v-else>
            <template slot-scope="scope">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                  ...
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a"
                                    style="margin-bottom:6px;"><span @click="handleToApplyInfo(scope.row, scope.$index)"
                          style="font-size:16px;color: #409EFF;">
                      详情
                    </span></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <!-- <div class="left">
          <span>已选0条</span>
          <span class="xian"></span>
          <span style="marginRight:16px">批量</span>
          <p class="batch">删除</p>

        </div> -->
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
      <SeniorReview :visible="visible"
                    :rowDetail="rowDetail"
                    @handleClose="handleClose"
                    :curentSenior="curentSenior" />
      <UserSeniorPhone :visible="visiblePhone"
                       :rowDetail="rowDetail"
                       @phoneClose="phoneClose" />
    </div>
  </div>
</template>

<script>
import { seniorApplyList, seniorApplyDelete } from '@/api/senior'
import SeniorReview from '@/components/dialog/senior/seniorReview'
import UserSeniorPhone from '@/components/dialog/senior/userSeniorPhone'

export default {
  components: { SeniorReview, UserSeniorPhone },
  data() {
    return {
      visible: false,
      query: {
        keyword: '',
        status: '0',
        college: '',
        subject: '',
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
        is_invite_list: 1,
      },
      pageTotal: 1000,
      filter: {
        status: [
          { label: '全部', value: '' },
          { label: '待审核', value: '0' },
          { label: '已通过', value: '1' },
          { label: '已驳回', value: '2' },
        ],
      },
      results: [],
      invite_options: [],
      isfixed: document.body.clientWidth < 820 ? false : true,
      chooseList: [],
      rowDetail: {},
      visiblePhone: false,
      curentSenior: null,
    }
  },
  created() {
    this.parseQuery()
    this.fetchSeniorApplyList()
  },
  methods: {
    handleSelectionChange(val) {
      this.chooseList = val
    },
    handleClose() {
      this.visible = false
      this.fetchSeniorApplyList()
    },
    phoneClose() {
      this.visiblePhone = false
      this.fetchSeniorApplyList()
    },
    handleNickname(row) {
      this.visiblePhone = true
      this.rowDetail = row
    },
    // 申请列表
    fetchSeniorApplyList() {
      seniorApplyList(this.query).then((res) => {
        this.results = res.list || []
        this.results = this.results.map((item) => {
          // 1. 初始化 subject 为空数组（关键修复）
          item.subject = []
          // 2. 拆分代码和名称为数组
          const codes = item.test_subject_codes.split(',')
          const names = item.test_subject_names.split(',')
          // 3. 按索引对应组合（避免嵌套循环）
          for (let i = 0; i < codes.length && i < names.length; i++) {
            item.subject.push(`(${codes[i]})${names[i]}`)
          }
          return item // 注意：map 需要返回处理后的 item
        })
        this.pageTotal = res.count || 0
        this.invite_options = res.invite_list
      })
      this.syncQuery()
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchSeniorApplyList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchSeniorApplyList()
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.fetchSeniorApplyList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()
      this.fetchSeniorApplyList()
    },
    // 部分内容渲染
    handleRender(value, type) {
      let status = {
        0: '待审核',
        1: '审核通过',
        2: '审核驳回',
      }
      if (type == 'status') {
        return status[value] || ''
      }
      return ''
    },
    // 申请详情
    handleToApplyInfo(row) {
      if (row.current_senior_obj) {
        this.curentSenior = row.current_senior_obj
      }
      this.rowDetail = row
      this.visible = true
      // this.$router.push(`/senior/apply/detail/${row.id}`)
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key]
      })
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      )
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        })
    },
    handleToRemove(row) {
      // 二次确认删除
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning',
      })
        .then(() => {
          seniorApplyDelete({ id: row.id }).then((res) => {
            this.$message.success(`删除成功`)
            this.fetchSeniorApplyList()
          })
        })
        .catch(() => {})
    },
  },
}
</script>

<style scoped lang="less">
::v-deep .el-table__fixed-right {
  background: #fff;
  z-index: 99 !important; /* 数值需高于滚动内容的z-index */
}
.admin {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .header-title {
      display: flex;
      .blue {
        margin-right: 8px;
        width: 4px;
        height: 20px;
        background: #409eff;
        border-radius: 4px 4px 4px 4px;
      }
    }
    .values {
      .seniorImg {
        margin-left: 3px;
        width: 20.71px;
        height: 10px;
      }
    }
    .footer {
      display: flex;
      justify-content: space-around;

      margin-top: 20px;

      .left {
        display: flex;
        align-items: center;
        .xian {
          margin-left: 16px;
          margin-right: 16px;
          width: 1px;
          height: 20px;
          background: #dcdfe6;
          border-radius: 0px 0px 0px 0px;
        }
        .batch {
          text-align: center;
          line-height: 26px;
          width: 46px;
          height: 26px;
          border-radius: 4px 4px 4px 4px;
          border: 1px solid #f56c6c;
          font-weight: 400;
          font-size: 13px;
          color: #f56c6c;
        }
      }
    }
  }
}
</style>
